export default __webpack_public_path__ + "static/media/background-video-bg.0ccedaee.jpg";